/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import ErrorBoundaryComponent from "components/ErrorBoundary";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "actions/core/core.actions";

// Enhanced Error Boundary with better error handling and logging
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
      eventId: null,
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { 
      hasError: true, 
      error: error 
    };
  }

  componentDidCatch(error, errorInfo) {
    // Enhanced error logging with more context
    const errorDetails = {
      error: error.toString(),
      stack: error.stack,
      componentStack: errorInfo.componentStack,
      app: process.env.REACT_APP_TYPE,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      url: window.location.href,
    };

    // Store error info in state for display
    this.setState({
      error,
      errorInfo,
    });

    // Log to external service
    if (this.props.addAppErrorLog) {
      this.props.addAppErrorLog(errorDetails);
    }

    // Log to console in development
    if (process.env.NODE_ENV === 'development') {
      console.group('🚨 Error Boundary Caught an Error');
      console.error('Error:', error);
      console.error('Error Info:', errorInfo);
      console.error('Error Details:', errorDetails);
      console.groupEnd();
    }

    // Optional: Send to error reporting service (Sentry, LogRocket, etc.)
    // if (window.Sentry) {
    //   window.Sentry.captureException(error, {
    //     contexts: {
    //       react: {
    //         componentStack: errorInfo.componentStack,
    //       },
    //     },
    //   });
    // }
  }

  handleRetry = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null,
      eventId: null,
    });
  };

  render() {
    const { hasError, error, errorInfo } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <ErrorBoundaryComponent 
          error={error}
          errorInfo={errorInfo}
          onRetry={this.handleRetry}
        />
      );
    }

    return children;
  }
}

// Mapping Props and State.
const errorBoundary = connect(
    ({ bootupInfo }) => ({
      bootupInfo,
      reqStatus: bootupInfo.reqStatus,
      isLoading: bootupInfo.isLoading,
      serviceError: bootupInfo.serviceError,
      serviceCode: bootupInfo.serviceCode,
    }),
    (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(ErrorBoundary);

export { errorBoundary as default };
